import { ApiServiceProps } from "DataTypes/Services/Index.type";
import { post } from "Service";

const TemplateSearch: (data: ApiServiceProps) => any = (data) => {
  const request = {
    subUrl: `question/${data.id1}/v2/template-search`,
  };
  return post(request);
};

const CreatePlan: (data: ApiServiceProps) => any = (data) => {
  const request = {
    subUrl: `pre-approved-plan/${data.id1}/create-plan`,
    data: { data: data.data },
  };
  return post(request);
};

const PlanList: (data: ApiServiceProps) => any = (data) => {
  const request = {
    subUrl: "pre-approved-plan/list-search",
    data: { data: data.data },
  };
  return post(request);
};

const PlanSearch: (data: ApiServiceProps) => any = (data) => {
  const request = {
    subUrl: `pre-approved-plan/${data.id1}/detail-search`,
  };
  return post(request);
};

const AddUpdateOption: (data: ApiServiceProps) => any = (data) => {
  const request = {
    subUrl: "pre-approved-plan/add-update-option",
    data: { data: data.data },
  };
  return post(request);
};

const ApprovePlan: (data: ApiServiceProps) => any = (data) => {
  const request = {
    subUrl: `pre-approved-plan/${data.id1}/approved`,
  };
  return post(request);
};

const DeletePlan: (data: ApiServiceProps) => any = (data) => {
  const request = {
    subUrl: `pre-approved-plan/${data.id1}/delete-plan`,
  };
  return post(request);
};

const DeleteOption: (data: ApiServiceProps) => any = (data) => {
  const request = {
    subUrl: `pre-approved-plan/${data.id1}/planoption-delete`,
  };
  return post(request);
};

const PrblmWithActivePlanList: (data: ApiServiceProps) => any = (data) => {
  const request = {
    subUrl: `pre-approved-plan/${data.id1}/active-plans`,
  };
  return post(request);
};

const CreatePAPForCP: (data: ApiServiceProps) => any = (data) => {
  const request = {
    subUrl: "pre-approved-plan/create-goals",
    data: { data: data.data },
  };
  return post(request);
};

const DeletePAPForCP: (data: ApiServiceProps) => any = (data) => {
  const request = {
    subUrl: "pre-approved-plan/goals-delete",
    data: { data: data.data },
  };
  return post(request);
};

const SearchPAPForCP: (data: ApiServiceProps) => any = (data) => {
  const request = {
    subUrl: "pre-approved-plan/goals-search",
    data: { data: data.data },
  };
  return post(request);
};

const EditPAPForCP: (data: ApiServiceProps) => any = (data) => {
  const request = {
    subUrl: "pre-approved-plan/mark-plan-edited",
    data: { data: data.data },
  };
  return post(request);
};

const AddUpdateCPOption: (data: ApiServiceProps) => any = (data) => {
  const request = {
    subUrl: "pre-approved-plan/add-update-careplan-option",
    data: { data: data.data },
  };
  return post(request);
};

const DeleteCPOption: (data: ApiServiceProps) => any = (data) => {
  const request = {
    subUrl: `pre-approved-plan/${data.id1}/delete-careplan-option`,
  };
  return post(request);
};

const PAPSummary: (data: ApiServiceProps) => any = (data) => {
  const request = {
    subUrl: `pre-approved-plan/${data.id1}/preapproved-plan-summary`,
  };
  return post(request);
};

export default {
  TemplateSearch,
  CreatePlan,
  PlanSearch,
  PlanList,
  AddUpdateOption,
  ApprovePlan,
  DeletePlan,
  DeleteOption,
  PrblmWithActivePlanList,
  CreatePAPForCP,
  DeletePAPForCP,
  SearchPAPForCP,
  EditPAPForCP,
  AddUpdateCPOption,
  DeleteCPOption,
  PAPSummary
}